import { getAppHydration, getHydrationPoint, getManagerHydration } from './hydration.js';
import { appendCacheQueryString, getCurrentScript } from './script.js';
export class Manifest {
    constructor(templateConfig, testGuid) {
        this._templateConfig = templateConfig;
        this.testGuid = testGuid;
    }
    get isDevelopment() {
        // import.meta.env.DEV is vite's way of referencing the development environment
        return process.env.NODE_ENV === 'development';
    }
    get version() {
        return this._templateConfig.version;
    }
    get packageName() {
        return this._templateConfig.name;
    }
    get code() {
        return `${this.packageName}-v${this.version}`;
    }
    get proxy() {
        // TODO: expose this without it being bundled
        // return (packageJson as any)['proxy'];
        return;
    }
    get bypassAppManager() {
        // tslint:disable-next-line: no-boolean-literal-compare
        return this._templateConfig.bypassAppManager;
    }
    get ksysAppTemplateId() {
        return `${this.packageName}`;
    }
    get storeKey() {
        return `${this.ksysAppTemplateId}-v${this.version}-store`;
    }
    get externalScripts() {
        const scripts = [];
        if (!this.isDevelopment) {
            const { dependencies } = this._templateConfig;
            if (dependencies) {
                const { vendor, internal } = dependencies;
                // scripts.push(vendor);
                scripts.push('https://unpkg.com/react@18.2.0/umd/react.production.min.js');
                scripts.push('https://unpkg.com/react-dom@18.2.0/umd/react-dom.production.min.js');
                scripts.push('https://unpkg.com/mobx@6.7.0/dist/mobx.umd.production.min.js');
                scripts.push('https://unpkg.com/mobx-react-lite@3.4.0/dist/mobxreactlite.umd.production.min.js');
                scripts.push('https://unpkg.com/mobx-react@7.6.0/dist/mobxreact.umd.production.min.js');
                scripts.push('https://unpkg.com/react-virtualized@9.22.3/dist/umd/react-virtualized.js');
                internal.forEach((pkg) => {
                    scripts.push(pkg);
                });
            }
        }
        // Polyfill URL API
        if (typeof window.URL !== 'function') {
            scripts.push('https://unpkg.com/url-polyfill@1.1.5/url-polyfill.js');
        }
        const managerAppResponse = getManagerHydration();
        const managerAssetCacheOptions = managerAppResponse &&
            managerAppResponse.applicationConfiguration &&
            managerAppResponse.applicationConfiguration.core &&
            managerAppResponse.applicationConfiguration.core.assetCacheOptions;
        if (managerAssetCacheOptions) {
            scripts.forEach((script, index) => {
                if (typeof script === 'string') {
                    scripts[index] = appendCacheQueryString(script, undefined, managerAssetCacheOptions);
                }
                else {
                    script.src = appendCacheQueryString(script.src, undefined, managerAssetCacheOptions);
                }
            });
        }
        return scripts;
    }
    /**
     * This guid is only used for local development testing (where do not have a script tag to pull an application code off of)
     *
     * @readonly
     */
    get testGuid() {
        if (this.isDevelopment) {
            return this._testGuid;
        }
    }
    set testGuid(value) {
        this._testGuid = value;
    }
    // Sending in `appParamsHelper as any` because we have dependencies on scripts that aren't injected in the page yet
    getBaseUrlPrefix(appParamsHelper) {
        let response = '';
        // define prefix based on hydration
        const hydrationPoint = getHydrationPoint();
        if (hydrationPoint && hydrationPoint.javascript && appParamsHelper) {
            const managerAppResponse = getManagerHydration();
            // Sending in `appParamsHelper as any` because we have dependencies on scripts that aren't injected in the page yet
            const appResponse = getAppHydration(this, appParamsHelper);
            if (appResponse && managerAppResponse) {
                const { app } = appResponse;
                const { applicationCode } = app;
                const { templateConfiguration } = managerAppResponse;
                const host = templateConfiguration && templateConfiguration.externalScriptsBasePath;
                return `${host}/applicationManager/apps/${applicationCode}`;
            }
        }
        // else determine prefix based on script
        const scriptFilename = `/main-${this.packageName}.js`;
        const currentScript = getCurrentScript(this);
        const url = currentScript && currentScript.src;
        if (url) {
            const index = url.indexOf(scriptFilename);
            if (index > -1) {
                response = `${url.substr(0, index)}`;
            }
        }
        return response;
    }
    // Sending in `appParamsHelper as any` because we have dependencies on scripts that aren't injected in the page yet
    getBaseUrl(suffix = 'services/', appParamsHelper) {
        const baseUrl = `${this.getBaseUrlPrefix(appParamsHelper)}/${suffix}`;
        if (baseUrl && baseUrl !== '') {
            // if absolute just return as is
            if (baseUrl.startsWith('http')) {
                return baseUrl;
            }
            // setup base url origin
            const currentUrl = new URL(window.location.href);
            const origin = currentUrl.origin;
            return `${origin}${!baseUrl.startsWith('/') ? '/' : ''}${baseUrl}`;
        }
        return baseUrl;
    }
    getApplicationGuid(appParamsHelper) {
        const applicationUrlPath = this.isDevelopment ? this.proxy : this.getBaseUrlPrefix(appParamsHelper);
        if (applicationUrlPath) {
            const proxyParts = applicationUrlPath.split('/');
            if (proxyParts.length > 0) {
                return proxyParts[proxyParts.length - 1];
            }
        }
    }
    serialize() {
        const keys = [
            'packageName',
            'bypassAppManager',
            'externalScripts',
            'getBaseUrl',
            'ksysAppTemplateId',
            'packageName',
            'storeKey',
            'version',
        ];
        const response = {};
        keys.forEach((key) => {
            response[key] = this[key];
        });
        return response;
    }
}
//# sourceMappingURL=Manifest.js.map